export const KEY = "profile";

export const ProfileScreens = Object.freeze({
  Profile: "Profile",
  UpdateName: "UpdateName",
  UpdateEmail: "UpdateEmail",
  ConfirmDeletion: "ConfirmDeletion",
  VerifyEmail: "VerifyEmail",
});
